import { getAxiosInstance } from "../../../api";

export const saveDrumBallRecheck = async (body) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(`/drumball/recheck/save`, body);
    return res;
  } catch (error) {
    return error.response.data;
  }
};

export const passAllRecheck = async (params) => {
  try {
    const api = await getAxiosInstance();
    const res = await api.post(
      `/employee-dashboard/recheck/bulk-status-complete`,
      params,
    );
    return res;
  } catch (error) {
    return error.response.data;
  }
};
